import React from 'react'
import {VIEW_TYPES} from "../../utils/constants"
import MonthForm from "../MonthForm/MonthForm";

export default function ViewDateRangeSelector(props){
	switch(props.viewType){
		case VIEW_TYPES.MOST_RECENT:
			// most recent incrementor ... gets the report with the next most recent changes??
			return null
		case VIEW_TYPES.MONTHLY:
			return <MonthForm
				onSubmitCallback={props.changeDateRange}
			/>
		default:
			return null
	}
}

ViewDateRangeSelector.defaultProps = {
	viewType: VIEW_TYPES.MOST_RECENT,
	changeDateRange: () => console.log("ViewDateRangeSelector needs a changeDateRange function passed as prop")
}